import React from 'react';
import { FileX, Search, Calendar } from 'lucide-react';
import styles from './EmptyState.module.css';

interface EmptyStateProps {
  type?: 'default' | 'search' | 'contracts' | 'meetings';
  title?: string;
  description?: string;
  icon?: React.ReactNode;
  action?: React.ReactNode;
}

const EmptyState: React.FC<EmptyStateProps> = ({ type = 'default', title, description, icon, action }) => {
  const getDefaultContent = () => {
    switch (type) {
      case 'search':
        return {
          icon: <Search size={48} className={styles.emptyStateIcon} />,
          title: 'No results found',
          description: "Try adjusting your search criteria or filters to find what you're looking for."
        };
      case 'contracts':
        return {
          icon: <FileX size={48} className={styles.emptyStateIcon} />,
          title: 'No contracts found',
          description: 'There are no contracts matching your current filters.'
        };
      case 'meetings':
        return {
          icon: <Calendar size={48} className={styles.emptyStateIcon} />,
          title: 'No meetings scheduled',
          description: 'There are no meetings scheduled for the selected time period.'
        };
      default:
        return {
          icon: <FileX size={48} className={styles.emptyStateIcon} />,
          title: 'No data available',
          description: 'There is no data to display at the moment.'
        };
    }
  };

  const content = getDefaultContent();
  const displayIcon = icon || content.icon;
  const displayTitle = title || content.title;
  const displayDescription = description || content.description;

  return (
    <div className={styles.emptyState}>
      <div className={styles.emptyStateContent}>
        <div className={styles.emptyStateIconContainer}>{displayIcon}</div>
        <h3 className={styles.emptyStateTitle}>{displayTitle}</h3>
        <p className={styles.emptyStateDescription}>{displayDescription}</p>
        {action && <div className={styles.emptyStateAction}>{action}</div>}
      </div>
    </div>
  );
};

export default EmptyState;
